// extracted by mini-css-extract-plugin
export default {"picture":"index_picture_5lgOV"};